module.exports = __webpack_public_path__ + "img/loading.a8b43f13.svg";